import { gql, type TypedDocumentNode } from '@apollo/client'

import { SavingsAccountContentEntitySavingsAccountProductFragmentDoc } from './SavingsAccountContent/SavingsAccountContent.generated'

export type SavingsStartupModalEntityFragment = {
  __typename?: 'Entity'
  canCreateAccount: boolean | null
  savingsAccountProduct: {
    __typename?: 'EntitySavingsAccountProduct'
    baseInterestRate: string | null
    bonusInterestRate: string | null
    bonusLengthInDays: string | null
    effectiveInterestRate: string | null
  } | null
}

export type SavingsStartupModalDebitCardAccountV2Fragment = {
  __typename?: 'DebitCardAccountV2'
  id: string
}

export const SavingsStartupModalEntityFragmentDoc = gql`
  fragment SavingsStartupModalEntityFragment on Entity {
    canCreateAccount
    savingsAccountProduct {
      ...SavingsAccountContentEntitySavingsAccountProductFragment
    }
  }
  ${SavingsAccountContentEntitySavingsAccountProductFragmentDoc}
` as unknown as TypedDocumentNode<SavingsStartupModalEntityFragment, undefined>
export const SavingsStartupModalDebitCardAccountV2FragmentDoc = gql`
  fragment SavingsStartupModalDebitCardAccountV2Fragment on DebitCardAccountV2 {
    id
  }
`
